import { B2CPolicy } from 'src/app/core/constants/btc-policies';
import { IEnvironmentVariables } from './IEnvironment';

const authorityBaseUrl = 'https://mncportalqa.b2clogin.com/tfp/mncportalqa.onmicrosoft.com';

const API_URL = {
  Platform: 'https://api-platform.portalqa.mynexuscare.com',
  RR: 'https://api-resourcerouter.portalqa.mynexuscare.com',
};

const consentScopes = [
  'https://mncportalqa.onmicrosoft.com/api/api.Write',
  'https://mncportalqa.onmicrosoft.com/api/api.Read',
  'https://mncportalqa.onmicrosoft.com/api/user_impersonation',
];

export const environment: IEnvironmentVariables = {
  production: true,
  authConfig: {
    config: {
      auth: {
        authority: `${authorityBaseUrl}/${B2CPolicy.SignUpSignIn}`,
        clientId: '386a6be3-ed0d-4bcc-ac0a-178b0d194913',
        knownAuthorities: ['mncportalqa.b2clogin.com'],
        postLogoutRedirectUri: 'https://resourcerouter.portalqa.mynexuscare.com/login',
        redirectUri: 'https://resourcerouter.portalqa.mynexuscare.com/login',
      },
    },
    angularConfig: {
      consentScopes,
      protectedResourceMap: Object.values(API_URL).map((url) => [url, consentScopes]),
    },
  },
  authorityBaseUrl,
  api: API_URL,
};
